<template>
  <div :class="['pages',bgStatus]">
    
    <div class="pages-body" v-for="(row,i) in menuList" :key="row.name" :id="row.name" >
      <div class="pages-body-title" v-show="i > 0">
        <span :class="['osuu', row.icon]"></span>
        {{row.name}}
      </div>
      <Row :gutter="20">
        <Col :xl="6" :lg="6" :md="8" :sm="24" :xs="24" v-for="(item,index) in row.list" :key="index">
          <card >
            <div @click="toUrl(item.url)">
              <div class="cover">
                <img :src="require('@/'+ item.icon)">
              </div>
              <div class="info">
                <div class="title">
                  <a href="">{{item.name}}</a>
                </div>
              </div>
              <div class="desc">{{item.url}}</div>
            </div>
          </card>
        </Col>
      </Row>
    </div>
    
    <!-- 配置备案号 -->
    <CopyrightIcp></CopyrightIcp>
<!-- <Footer></Footer> -->
    <!-- <a style="bottom:2%;position:fixed;text-align:center" href='https://beian.miit.gov.cn/' target='_blank'>备案号：闽ICP备2024046577号-1</a> -->
  </div>
</template>

<script>
import CopyrightIcp from '@/components/copyright-icp.vue';

  import {
    mapMutations
  } from "vuex";
  export default {
    data() {
      return {
        // menuList: window.config.menuList
        menuList: [
          {
            name: "管理系统",
            icon: "geek-tuijian",
            list: [
              {
                name: "八达通APP",
                desc: "八达通运输管理系统",
                url: "https://npbdt.com/update/bdt.apk",
                icon: "assets/images/qrcode/bdtApk.png"
              },
              {
                name: "八达通油库APP",
                desc: "八达通油库管理系统",
                url: "https://npbdt.com/update/bdtoil.apk",
                icon: "assets/images/qrcode/bdtoilApk.png"
              },
              {
                name: "启正APP",
                desc: "启正运输管理系统",
                url: "https://npbdt.com/update/qz.apk",
                icon: "assets/images/qrcode/qzApk.png"
              },
              {
                name: "睿达APP",
                desc: "睿达钩机管理系统",
                url: "https://npbdt.com/update/jxq.apk",
                icon: "assets/images/qrcode/jxqApk.png"
              },
              {
                name: "油库APP",
                desc: "八达通油库管理系统",
                url: "https://npbdt.com/update/oil.apk",
                icon: "assets/images/qrcode/oilApk.png"
              },
              {
                name: "八达通手机网页",
                desc: "八达通手机网页",
                url: "https://npbdt.com/badatong-mobile",
                icon: "assets/images/qrcode/badatong-mobile.png"
              },
              {
                name: "八达通油库手机网页",
                desc: "八达通油库手机网页",
                icon: "assets/images/qrcode/bdtoil-mobile.png",
                url: "https://npbdt.com/bdtoil-mobile"
              },
              {
                name: "启正手机网页",
                desc: "启正手机网页",
                url: "https://npbdt.com/qz-mobile",
                icon: "assets/images/qrcode/qz-mobile.png"
              },
              {
                name: "油库手机网页",
                desc: "油库手机网页",
                icon: "assets/images/qrcode/oil-mobile.png",
                url: "https://npbdt.com/oil-mobile"
              },
              {
                name: "睿达手机网页",
                desc: "睿达手机网页",
                icon: "assets/images/qrcode/jxq-mobile.png",
                url: "https://npbdt.com/jxq-mobile"
              },
            ]
          }
        ]
      };
    },
    components: {
      CopyrightIcp
    },
    created() {
      let now = new Date(),
        hour = now.getHours()
      if (hour < 9 || hour > 20) {
        this.bgStatus = "night"
      } else {
        this.bgStatus = "day"
      }
      //获取本地文件中的IP地址

    },
    methods: {
      ...mapMutations(["goUrl"]),
      searchClick() {
        this.goUrl(this.searchItem + this.searchValue)
      },
      toUrl(e) {
        //console.log(window.config.camServer)
        this.goUrl(e)
      },
      selectChange(e) {
        localStorage.setItem('searchItem', e)
      }
    },
  };
</script>

<style scoped lang="less">
  .cover {
    width: 150px;
    height: 150px;
    margin-bottom: -5px;
    overflow: hidden;
    cursor: pointer;
  }

  img {
     transform: translateY(-40%);
     position: absolute;
     margin-left: 32px;
     top: 30%;
    width: 150px;
    height: 150px;
    /*margin: 0 auto;*/
  }

  .title {
    font-size: 14px;
    text-align: left;
  }

  .author {
    color: #333;
    width: 102px;
    font-size: 13px;
    margin-bottom: 6px;
    text-align: left;
  }

  .abstract {
    display: block;
    line-height: 17px;
  }

  a {
    text-decoration: none;
  }

  a:link, a:visited, a:focus {
    color: #ff0000;
  }
  .pages {
    min-height: 100vh;
    position: relative;
    padding-top: 50px;
    padding-bottom: 20px;
      .showMenu {
        background: #fff;
        opacity: 0.2;
        position: fixed;
        top: 20px;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        transition: all .3s;
        cursor: pointer;
        z-index: 4000;
        box-shadow: 1px 1px 5px #888888;

        span {
          font-size: 30px;
          color: #272525;
        }
      }
    }

    .pages-body {
      margin: 10px auto;
      padding: 10px 20px;
      max-width: 1152px;
      border-radius: 5px;
      background: #ffffff;
      .pages-body-title {
        font-size: 16px;
        font-weight: 600;
      }

      .ivu-card {
        cursor: pointer;
        position: relative;
        margin: 10px 0;

        .logo {
          float: left;
          padding: 7px 0;

          img {
            width: 150px;
            height: 150px;
          }
        }

        .cont {
          // transform: translateY(-50%);
         // position: absolute;
          // margin-left: 50px;
          // top: 50%;

          .name {
            font-size: 18px;
            font-weight: 700;
            color: #3273dc;
            white-space: nowrap;
            //overflow: hidden;
            //text-overflow: ellipsis;
          }

          .desc {
            color: gray;
            font-size: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

  .day {
    background: url("../assets/images/day_cloud.png"), linear-gradient(180deg, #0260ac, #3992e0 36%, #9ce0fe 77%, #eff9fd);
  }

  .night {
    background-image: url('../assets/images/night_star.png'), linear-gradient(180deg, #1c1e25, #1d516d 40%, #f0f4f5 80%);
  }

  @media (max-width: 1200px) {

    .pages-body
  }

  @media (max-width: 992px) {
    .pages {
      padding-top: 10px;
      height: 70%;

    }

    .pages-body {
      width: 95% !important;
      height: 70%;
    }
  }
        .box {
          margin-top: 150px;
          font-size: 36px;
          color: orangered;
            width: 100%;
            text-align: center; /*给父元素设置text-align*/
        }
 
</style>